<template>
  <div id="app">
    <router-view :key="$route.path + $route.query.a" />
  </div>
</template>

<script>
export default {
  name: "App",
  created() {
    if (this._isMobile()) {
      window.location.href = "http://fcdn.ytowin.com/Subjects/601854ad1abe/#/";
    }
  },
  mounted() {
    this.$cookies.config("1d", ".ytowin.com");
    let XUIDcK = this.$cookies.get("XUID");
    //     if ((XUIDcK ==null)) {
    //   window.location.href = "http://www.ytowin.com";
    // }else if(this.$cookies.get("QE_FD") !=this.$md5(XUIDcK).toUpperCase()){
    //   window.location.href = "http://www.ytowin.com";
    // }
  },
  watch: {
    $route: function(to, from) {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      window.scrollTo(0, 0);
    }
  },
  methods: {
    //App.vue
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    }
  }
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
  font-family: "Microsoft YaHei", "PingFang SC", "SimSun", "Arial", sans-serif;
}

a {
  text-decoration: none;
  color: inherit;
}

a:hover {
  text-decoration: none;
}

ul,
li,
ol {
  list-style: none;
}
/* 内容版心 */
.ct-centre {
  width: 1200px;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/App.vue